import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Moment from 'react-moment'
import moment from 'moment'
import 'moment/locale/pt-br'

import metaStyles from './meta.module.scss'

const Meta = ({ article }) => {
  const data = useStaticQuery(graphql`
    query metaArticleQuery {
      site {
        siteMetadata {
          articleMetadata {
            dateText
            metaLabel1
            metaLabel2
            metaLabel3
          }
        }
      }
    }
  `)

  const metadata = data.site.siteMetadata.articleMetadata

  moment.locale('pt-br')
  const publishedAt = moment(article.date)

  return (
    <footer
      className={`${metaStyles.meta} ${
        article.num_chapter === 0 ? metaStyles.home : ''
      }`}
    >
      <span className={`timestamp ${metaStyles.timestamp}`}>
        {metadata.dateText}
        {` `}
        <br className="hidden-xs hidden-sm" />
        <Moment format="LL">{publishedAt}</Moment>
      </span>
      <dl className={metaStyles.list}>
        <dt className={metaStyles.authorTitle}>{metadata.metaLabel1}</dt>
        <dd className={metaStyles.authorName} itemProp="author">
          {article.author}
        </dd>
        <dt className={metaStyles.authorTitle}>{metadata.metaLabel2}</dt>
        <dd className={metaStyles.authorName} itemProp="author">
          {article.photographer}
        </dd>
        <dt className={metaStyles.authorTitle}>{metadata.metaLabel3}</dt>
        <dd className={metaStyles.authorName} itemProp="author">
          {article.editor}
        </dd>
      </dl>
    </footer>
  )
}

export default Meta
